import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import type { ApiKey, DataEnvelope } from './types';

const key = ['api-keys'] as const;

export function useApiKeys() {
  return useQuery({
    queryKey: key,
    queryFn: ({ signal }) => api<DataEnvelope<ApiKey[]>>('/api-keys', { signal }).then((r) => r.data),
  });
}

export function useCreateApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; scope: 'read' | 'write' }) =>
      api<DataEnvelope<{ key: string; apiKey: ApiKey }>>('/api-keys', { method: 'POST', body: input }).then(
        (r) => r.data,
      ),
    onSuccess: () => void qc.invalidateQueries({ queryKey: key }),
  });
}

export function useRevokeApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api<void>(`/api-keys/${id}`, { method: 'DELETE' }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: key }),
  });
}
